module.exports = __webpack_public_path__ + "static/fonts/montserrat-bold.88932da.ttf";